import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';

// request Types!
type reqSearchBoxType = {
  userId: string;
  tabType: string;
  test: string;
};

type reqGridDataType = {
  userId: string;
  tabType: string;
  appInfo?: any;
  appId?: string;
};

type reqkeywordType = {
  userId: string;
  tabType: string; // title/subtitle/keywords/description
  reqType: string; // add/del 버튼
  boxType: string; // searchBox / analysisBox 컴포넌트 구분
  keyword: string;
  group?: string | null;
  keywordId?: string;
};

type reqDescHeaderType = {
  userId: string;
  tabType: string; // title/subtitle/keywords/description
  reqType: string; // add/del 버튼
  boxType: string; // searchBox / analysisBox 컴포넌트 구분
  appId: string; // appId
  appTitle: string; // appTitle
};

// TODO: 추후 삭제처리할것..
const objMakingGenerator = (text) => {
  const regex = /^(?!,$)[\d,.]+$/gi; //, . 제거 regex
  const tempArray = text.replaceAll(regex, '').split(' ');
  // 중복제거
  const textArray = Array.from(new Set(tempArray));
  const result = textArray.map((item, index) => {
    let temp = {};
    temp['id'] = index;
    temp['keyword'] = item;
    temp['searchscore'] = Math.round(Math.random() * 100);
    temp['group'] = [null, 'group1', 'group2', 'group3', 'group4'][Math.round((Math.random() * 10) % 4)];
    temp['tracked'] = false;
    return temp;
  });
  console.log('result: ', result);
  return result;
};
// TODO: 임시함수임..
const makeKeywordsObjList = (keywordsList) => {
  return keywordsList.map((item, index) => ({
    ...item,
    searchscore: Math.floor(Math.random() * 100),
    rank: Math.floor(Math.random() * 1000),
    title: [true, false][Math.round(Math.random())],
    sub: [true, false][Math.round(Math.random())],
    asck: [true, false][Math.round(Math.random())],
    group: [null, 'group1', 'group2', 'group3', 'group4'][Math.round(Math.random() * 10) % 4],
    missingkeyword: `test${index}`,
  }));
};
// TODO: 임시함수임..
const changeKeywordsList = (titleCompetitorsKeywordsList, currentKeywordList) => {
  let result = currentKeywordList.filter((item) => {
    return !titleCompetitorsKeywordsList.some((formerItem) => formerItem.id === item.id);
  });
  result = makeKeywordsObjList(result);
  return result;
};

//TODO: 임시함수임...
const objDescriptionMakingGenerator = (text) => {
  const regex = /^(?!,$)[\d,.]+$/gi; //, . 제거 regex
  const tempArray = text.replaceAll(regex, '').split(' ');
  // 중복제거
  const textArray = Array.from(new Set(tempArray));
  const result = [];
  textArray.forEach((item, index) => {
    let temp = {};
    temp['id'] = index.toString();
    temp['keyword'] = item;
    temp['averageCount'] = Math.round(Math.random() * 100);
    temp['averagePercent'] = parseFloat(Math.random().toFixed(2));
    temp['tracked'] = false;
    temp['appObj'] = [
      {
        appId: '11',
        appTitle: 'onepiece',
        appIcon:
          'https://play-lh.googleusercontent.com/Gu1OsB9B5vADzqAjsSzTzox8GQ87Ty0xSXKAMzg4Ptu2R0r5UbfjNCGG16_mnRCuRyqG',
        count: Math.round(Math.random() * 100),
        percent: parseFloat(Math.random().toFixed(2)),
      },
      {
        appId: '22',
        appTitle: 'bleach',
        appIcon:
          'https://play-lh.googleusercontent.com/DwS57XZzqmTeA-n_jNOCrX03J7TvOmDw9EHuS-w7TK8oWK9A73em12-K0V3BNtkBSA',
        count: Math.round(Math.random() * 100),
        percent: parseFloat(Math.random().toFixed(2)),
      },
      {
        appId: '33',
        appTitle: 'clashofclan',
        appIcon:
          'https://play-lh.googleusercontent.com/akv2Bdp7i5Vv-sl9FuP3_dhWpUO80zULf-Pkh6RFleomEp6pZorHuCNm3FbR9oAMunVK',
        count: Math.round(Math.random() * 100),
        percent: parseFloat(Math.random().toFixed(2)),
      },
      {
        appId: '44',
        appTitle: 'tictok',
        appIcon:
          'https://play-lh.googleusercontent.com/z5nin1RdQ4UZhv6fa1FNG7VE33imGqPgC4kKZIUjgf_up7E-Pj3AaojlMPwNNXaeGA',
        count: Math.round(Math.random() * 100),
        percent: parseFloat(Math.random().toFixed(2)),
      },
      {
        appId: '55',
        appTitle: 'pinball',
        appIcon:
          'https://play-lh.googleusercontent.com/pLNRB_cqyDiSz9fv99aIWlGvC0peS8Rw_sBD6JXoO3LyQQu6uTNtcTSbff2U7EeSiNgD',
        count: Math.round(Math.random() * 100),
        percent: parseFloat(Math.random().toFixed(2)),
      },
      {
        appId: '66',
        appTitle: 'baseball',
        appIcon:
          'https://play-lh.googleusercontent.com/fXx7D56dGOUu79OWDXfDzvnUBRFqguxqS0TEWcEtFbBbjXuKD9QeuMdjo4UThlqFo3g',
        count: Math.round(Math.random() * 100),
        percent: parseFloat(Math.random().toFixed(2)),
      },
    ];
    result.push(temp);
  });
  console.log('result: ', result);
  return result;
};

// searchBox gridData 요청
export const fetchSearchBoxData = createAsyncThunk('fetchSearchBoxData', async (params: reqSearchBoxType) => {
  try {
    return objMakingGenerator(params.test);
  } catch (error) {
    console.log('fetchSearchBoxDataError: ', error);
  }
});

// analysisBox gridData 요청
export const fetchAnalysisBoxData = createAsyncThunk('fetchAnalysisBoxData', async (params: reqGridDataType) => {
  try {
    const { data, status } = await axiosDummyInstance.get('/api/keyword/keywordOptimizationAlaysisBoxData.json', {
      params,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.log('fetchAnalysisBoxDataError: ', error);
  }
});

// competitorBox gridData 요청
export const fetchCompetitorBoxData = createAsyncThunk('fetchCompetitorBoxData', async (params: reqGridDataType) => {
  try {
    console.log('fetchCompetitorBoxData 요청 확인용!!', fetchCompetitorBoxData);
    const { data, status } = await axiosDummyInstance.get('/api/keyword/keywordOptimizationCompetitors.json', {
      params,
    });
    if (status === 200) {
      console.log('data777: ', data);
      return data;
    }
  } catch (error) {
    console.log('fetchCompetitorBoxDataError: ', error);
  }
});

// searchBox, analysisBox keyword add/Del 요청
export const fetchReqKeyword = createAsyncThunk('fetchReqKeyword', async (params: reqkeywordType) => {
  try {
    const { userId, tabType, reqType, boxType, keyword, group } = params;
    const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params: params });
    if (status === 200) {
      // 여기서 성공시 competitorBox 데이터 요청 처리
      // TODO: 추후 POST 로 변경처리해야함
      // add/del 변경처리는 slice 에서 처리
      // ex) searchBox add/del 요청시 -> analysisBox add/del 아이콘처리는 slice 에서 params 기준으로 원 keywordList tracked 변경처리
      const { data: compData, status: compStatus } = await axiosDummyInstance.get(
        '/api/keyword/keywordOptimizationCompetitors.json',
        {
          params,
        }
      );
      if (compStatus === 200) {
        return {
          competitorsData: compData,
          params: params,
        };
      }

      // return params;
    }
  } catch (error) {
    console.log('fetchReqKeywordError: ', error);
  }
});

// description searchBox Request
export const fetchDescriptionSearchBox = createAsyncThunk(
  'fetchDescriptionSearchBox',
  async (params: reqSearchBoxType) => {
    try {
      return objDescriptionMakingGenerator(params.test);
    } catch (error) {
      console.log('fetchDescriptionSearchBoxError: ', error);
    }
  }
);

// description add/del keyword
export const fetchDescriptionAddDelButton = createAsyncThunk(
  'fetchDescriptionAddDelButton',
  async (params: reqkeywordType) => {
    try {
      const { userId, reqType, tabType, boxType, keywordId, keyword } = params;
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        // 여기서 성공시 competitorBox 데이터 요청 처리
        // TODO: 추후 POST 로 변경처리해야함
        // add/del 변경처리는 slice 에서 처리
        // ex) searchBox add/del 요청시 -> analysisBox add/del 아이콘처리는 slice 에서 params 기준으로 원 keywordList tracked 변경처리
        const { data: compData, status: compStatus } = await axiosDummyInstance.get(
          '/api/keyword/keywordOptimizationCompetitors.json',
          {
            params,
          }
        );
        if (compStatus === 200) {
          return {
            competitorsData: compData,
            params: params,
          };
        }
      }
    } catch (error) {
      console.log('fetchDescriptionAddDelKeywordError: ', error);
    }
  }
);

// description add/del Header
export const fetchDescriptionAddDelHeader = createAsyncThunk(
  'fetchDescriptionAddDelHeader',
  async (params: reqDescHeaderType) => {
    try {
      const { userId, tabType, reqType, boxType, appId, appTitle } = params;
      // 여기서 성공시 competitorBox 데이터 요청 처리
      // TODO: 추후 POST 로 변경처리해야함
      // add/del 변경처리는 slice 에서 처리
      // ex) searchBox add/del 요청시 -> analysisBox add/del 아이콘처리는 slice 에서 params 기준으로 원 keywordList tracked 변경처리
      const { data: compData, status: compStatus } = await axiosDummyInstance.get(
        '/api/keyword/keywordOptimizationCompetitors.json',
        {
          params,
        }
      );
      if (compStatus === 200) {
        return {
          competitorsData: compData,
          params: params,
        };
      }
    } catch (error) {
      console.log('fetchDescriptionAddDelHeaderError: ', error);
    }
  }
);
